import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'embryo-Testimonial',
  templateUrl: './Testimonial.component.html',
  styleUrls: ['./Testimonial.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestimonialComponent implements OnInit {

   @Input() data : any;

   constructor() { }

   ngOnInit() {
   }

}
